module.exports = __webpack_public_path__ + "static/media/telegram.408fe586.png";